<template>
  <div class="content-viewer container-sm">
    <div
      v-if="hasExtraContent && !isDescription"
    >
      {{page.extra_content.title}}
      <div>
        <img class="extra-content-image" v-bind:src=page.extra_content.image_url>
      </div>
    </div>
    <template v-for="(el, index) in parsed">
      <template v-if="!ignorable(el, index)">
        <content-item
          v-if="isContentItem(el)"
          :key="index"
          :node="el"
          :page="page"
        />
      </template>
    </template>
  </div>
</template>

<script>
import himalaya from 'himalaya';
import { includes, some, isEmpty } from 'lodash';

const TAG_WHITELIST = [
  'h1',
  'p',
  'blockquote',
  'u',
  'b',
  'span',
  'sub',
  'sup',
  'ul',
  'ol',
  'iframe',
  'figure',
];

export default {
  name: 'content-viewer',

  props: [
    'page',
    'content',
    'isDescription',
  ],

  computed: {
    parsed() {
      return himalaya.parse(this.content || '');
    },
    hasExtraContent() {
      return !isEmpty(this.page.extra_content);
    },
  },

  methods: {
    isContentItem(node) {
      return includes(TAG_WHITELIST, node.tagName) || node.type === 'Text';
    },

    hasImageNode(node) {
      return node.children
          && node.children.length > 0
          && node.type === 'Element'
          && some(node.children, { tagName: 'img' });
    },

    ignorable(node, index) {
      if (index + 1 === this.parsed.length) {
        return node.tagName === 'p' &&
            node.children.length === 1 &&
            node.children[0].tagName === 'br';
      }

      return false;
    },
  },
};
</script>

<style lang="scss">
  @import '../assets/styles/components/_typographies';
  @import '../assets/styles/components/_breakpoints';

  .content-viewer .extra-content-image {
    margin: 8px 0;
    border: 1px solid #BBB;
    width: 100%;
  }

  .content-viewer h1 {
    font-size: 24px;
    font-weight: 300;
    line-height: 1.33;

    @media (min-width: $tablet-breakpoint) {
      font-size: 28px;
      line-height: 1.14;
    }
  }

  .content-viewer p {
    margin: 0;
    word-wrap: break-word;
    font-size: 17px;
    font-weight: 100;
    line-height: 1.65;

    @media (min-width: $tablet-breakpoint) {
      font-size: 20px;
      line-height: 1.6;
    }
  }

  .content-viewer {
    span,
    p {
      img {
        display: block;
        padding: 14px 0 14px 0;
        width: 100%;
        margin: 0 auto;
      }

      video {
        display: block;
        padding: 14px 0 14px 0;
        max-width: 100%;
        margin: 0 auto;
      }

      audio {
        display: none;
        max-width: 100%;
        padding: 14px 0 14px 0;
        margin: 0 auto;
      }

      @media (min-width: $tablet-breakpoint) {
        margin: 0;
      }
    }
  }

  .content-viewer b {
    font-weight: 300;
  }

  .content-viewer strong {
    font-weight: bold;
    font-weight: bolder;
  }

  .content-viewer {
    iframe {
      max-width: 100%;
      max-height: 360px;
      background: #000000;
    }
  }

  .content-viewer blockquote,
  .content-viewer blockquote p {
    font-size: 12px;
    line-height: 1.33;

    @media (min-width: $tablet-breakpoint) {
      font-size: 14px;
      line-height: 1.43;
    }

    margin: 0;
    font-style: normal;

    &:before,
    &:after {
      content: '';
    }
  }

  .json {
    border: 1px solid #ccc;
    height: 300px;
    overflow-y: auto;
  }
</style>
